var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Toast',{attrs:{"baseZIndex":99999,"breakpoints":{'920px': {width: '100%',
        right: '0',
        left: '0'}},"position":"bottom-left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }